import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { AttributeCode, InvestmentPreferences, UserAttributeInterface } from "../../../../../model/finzy-flex/user-attribute.model";
import { ProductType } from "../../../../../model/finzy-flex/finzy-flex-config.model";
import { SharedPreferenceDataService } from "../../../../../service/shared-preference-data.service";
import { ConfirmPopUpFinzyFlexComponent } from "../../confirm-pop-up-finzy-flex/confirm-pop-up-finzy-flex.component";
import { UserAttributeService } from "../../../../../service/finzy-flex/user/user-attribute.service";
import { Keys, StorageService } from "../../../../../service/storage.service";
import { Toaster, Type } from "../../../../../toaster/Toaster";
import { FfEndPoints } from "../../ff-endpoints";

@Component({
    selector: 'app-quick-setup',
    templateUrl: './quick-setup.component.html',
    styleUrls: ['./quick-setup.component.css']
})
export class QuickSetupComponent implements OnInit{
    private readonly sharedPreferenceDataService: SharedPreferenceDataService;
    private readonly userAttributeService: UserAttributeService;
    private readonly storageService: StorageService;
    private readonly matDialog: MatDialog;
    private readonly router: Router;
    private activatedRoute: ActivatedRoute;
    private isSwiftModified: boolean = false;
    private isNCashModified: boolean = false;
    @Input() isSwiftOn: boolean;
    @Input() isNCashOn: boolean;
    @Input() userAttributes: UserAttributeInterface = null;

    constructor(
        sharedPreferenceDataService: SharedPreferenceDataService,
        userAttributeService: UserAttributeService,
        storageService: StorageService,
        matDialog: MatDialog,
        router: Router,
        activatedRoute: ActivatedRoute,
    ) {
        this.sharedPreferenceDataService = sharedPreferenceDataService;
        this.matDialog = matDialog;
        this.router = router;
        this.userAttributeService = userAttributeService;
        this.storageService = storageService;
        this.activatedRoute = activatedRoute;
    }

    ngOnInit(): void {
    }


    async onTogglePreference(event: boolean, preferenceType: string) {
        if (preferenceType == 'isSwiftOn') {
            this.isSwiftOn = event;
            if (!event) {
                const result = await this.onOpenConfirmationPopup(ProductType.SWIFT, {
                    data: {
                        title: 'Switching Off Swift',
                        subTitle: 'Are your sure You want to switch off your Swift',
                        message: `By clicking on <strong>Turn OFF</strong> your swift settings will be reset. You cant retrieve your  preferences in the future.`,
                        positiveButtonText: 'Turn OFF',
                        negativeButtonText: 'Go Back',
                    },
                    width: '60%',
                    minWidth: 'fit-content',
                    panelClass: 'disable-preference-popup'
                });
                this.sharedPreferenceDataService.setSwiftValue(this.isSwiftOn);
                if (result) {
                    this.onFilterUserAttribute(ProductType.SWIFT, event);
                } else {
                    this.isSwiftOn = true;
                    this.sharedPreferenceDataService.setSwiftValue(this.isSwiftOn);
                }
                
            } else {
                this.isSwiftOn = false;
                this.router.navigateByUrl(FfEndPoints.PREFERENCES, {state: {
                    preferenceType: ProductType.SWIFT,
                    preferenceValue: true,
                }});
            }
        }
        if (preferenceType == 'isNCashOn') {
            this.isNCashOn = event;
            if (!event) {
                const result = await this.onOpenConfirmationPopup(ProductType.NCASH, {
                    data: {
                        title: 'Switching Off nCash',
                        subTitle: 'Are your sure You want to switch off your nCash',
                        message: `By clicking on <strong>Turn OFF</strong> your swift settings will be reset. You cant retrieve your  preferences in the future.`,
                        positiveButtonText: 'Turn OFF',
                        negativeButtonText: 'Go Back',
                    },
                    width: '60%',
                    minWidth: 'fit-content',
                    panelClass: 'disable-preference-popup'
                });
                this.sharedPreferenceDataService.setNCashValue(this.isNCashOn);
                if (result) {
                    this.onFilterUserAttribute(ProductType.NCASH, event);
                } else {
                    this.isNCashOn = true;
                    this.sharedPreferenceDataService.setNCashValue(this.isNCashOn);
                }
            } else {
                this.isNCashOn = false;
                this.router.navigateByUrl(FfEndPoints.PREFERENCES, {state: {
                    preferenceType: ProductType.NCASH,
                    preferenceValue: true,
                }});
            }
        }
    }

    private async onFilterUserAttribute(productType: ProductType, event: any) {
        try {
            if (productType == ProductType.NCASH) {
                const filteredPreferences = this.userAttributes.data[0].investmentPreferences.filter(
                    preference => ((preference.attributeCode == AttributeCode.INVESTMENT_FUND_ALLOCATION) ||
                        (preference.attributeCode == AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE) ||
                        (preference.attributeCode == AttributeCode.EMAIL_NOTIFICATION) ||
                        (preference.attributeCode == AttributeCode.FF_REINVEST_PRO) ||
                        (preference.attributeCode ==  AttributeCode.FF_REINVEST_PRO_FUND_ALLOCATION))
                    );
                this.userAttributes.data[0].investmentPreferences = filteredPreferences ?? [];
                this.isNCashModified = true;
            }
            if (productType == ProductType.SWIFT) {
                const filteredPreferences = this.userAttributes.data[0].investmentPreferences.filter(
                    preference => ((preference.attributeCode == AttributeCode.NCASH_WD_LIMIT) ||
                        (preference.attributeCode == AttributeCode.NCASH_WD_DATE_OF_MONTH) ||
                        (preference.attributeCode == AttributeCode.NCASH_WD_FREQUENCY) ||
                        (preference.attributeCode == AttributeCode.NCASH_WD_AMOUNT) ||
                        (preference.attributeCode == AttributeCode.EMAIL_NOTIFICATION) || 
                        (preference.attributeCode == AttributeCode.FF_REINVEST_PRO) ||
                        (preference.attributeCode ==  AttributeCode.FF_REINVEST_PRO_FUND_ALLOCATION))
                    );
                    this.userAttributes.data[0].investmentPreferences = filteredPreferences ?? [];
                    this.isSwiftModified = true;
            }
            const result = await this.onUpdateUserAttribute(this.userAttributes.data[0]);
            if (result?.errors) {
                if (productType == ProductType.NCASH) {
                    this.isNCashOn = !event;
                }
                if (productType == ProductType.SWIFT) {
                    this.isSwiftOn = !event;
                }
                Toaster.toast(result.errors[0].errorMessage, Type.Error);
            } else {
                Toaster.toast("The preference updated successfully", Type.Success);
                window.location.reload();
            }
        } catch(error) {
            if (productType == ProductType.NCASH) {
                this.isNCashOn = !event;
            }
            if (productType == ProductType.SWIFT) {
                this.isSwiftOn = !event;
            }
            return Toaster.toast(`Something went wrong.`, Type.Error);

        }
    }

    private async onUpdateUserAttribute(userAttribute: InvestmentPreferences) {
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        return await this.userAttributeService.putUserAttribute({automaticInvestmentsFromWallet: userAttribute.automaticInvestmentsFromWallet, investmentPreferences: userAttribute.investmentPreferences, userId: userAttribute?.userId, isNCashModified: this.isNCashModified, isSwiftModified: this.isSwiftModified} ,profileId);
    }

    private async onOpenConfirmationPopup(productType: ProductType, data): Promise<boolean> {
        if (productType == ProductType.NCASH) {
            return await this.matDialog.open(ConfirmPopUpFinzyFlexComponent, data).afterClosed().toPromise();
        }
        if (productType == ProductType.SWIFT) {
            return await this.matDialog.open(ConfirmPopUpFinzyFlexComponent, data).afterClosed().toPromise();
        }
    }
}